import React, { useEffect, useState, useRef } from 'react';
import { NavLink } from '../../../lib/Navigation';
import './css/css.css';

export default function HomeRecommend(props) {
  const [isVisible, setIsVisible] = useState(false);
  const contentRef = useRef(null);

  const calculateHeight = () => {
    if (contentRef.current) {
      const screenWidth = window.innerWidth > 720 ? 720 : window.innerWidth;
      const itemWidth = (screenWidth - 30 - 20 - 30) / 4;
      // 20px paddingTop + 20px paddingBottom + 45px header+margin (approx) + itemWidth
      const totalHeight = 85 + itemWidth;
      
      contentRef.current.style.height = isVisible ? `${totalHeight}px` : '0px';
    }
  };

  useEffect(() => {
    // Initial calculation
    calculateHeight();

    // Trigger animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    window.addEventListener('resize', calculateHeight);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', calculateHeight);
    };
  }, []);

  // Update height when visibility state changes for the transition
  useEffect(() => {
    calculateHeight();
  }, [isVisible]);

  const recommendGames = props.children || [];
  if (recommendGames.length === 0) return null;

  return (
    <div 
      key={recommendGames.map(game => game.game_id).join('-')}
      ref={contentRef}
      className={`index-recommend-games-component ${isVisible ? 'is-visible' : ''}`}
    >
      <div className="recommend-header">
        <img src="/resources/250627/left.png" alt="" height={1}/>
        <div className="recommend-header-content">
          <img src="/resources/250627/download.png" alt="" height={8}/>
          <div className='title'>为你推荐更多相似好游戏</div>
          <img src="/resources/250627/download.png" alt="" height={8}/>
        </div>
        <img src="/resources/250627/right.png" alt="" height={1}/>
      </div>
      <div className="recommend-grid">
        {recommendGames.map(game => (
          <NavLink user={false} to={`/game?id=${game.game_id}`} key={game.game_id} className="recommend-item">
            <img src={game.game_image.thumb} alt="" className="game-img" />
            <div className="game-name">{game.game_name}</div>
          </NavLink>
        ))}
      </div>
    </div>
  );
}
